import { render, staticRenderFns } from "./Supervised.vue?vue&type=template&id=2442f10f&"
import script from "./Supervised.vue?vue&type=script&lang=js&"
export * from "./Supervised.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports